<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path d="m10 18h4v-2h-4zm-7-12v2h18v-2zm3 7h12v-2h-12z" />
  </svg>
</template>
